import { useLanguage } from '../context/LanguageContext';

interface StreakDisplayProps {
  currentStreak: number;
  longestStreak: number;
}

export function StreakDisplay({ currentStreak, longestStreak }: StreakDisplayProps) {
  const { language } = useLanguage();

  const dayText = language === 'es'
    ? (currentStreak === 1 ? 'día' : 'días')
    : (currentStreak === 1 ? 'day' : 'days');

  const daysText = language === 'es' ? 'días' : 'days';
  const bestText = language === 'es' ? 'Mejor' : 'Best';

  return (
    <div className="flex items-center gap-4">
      <div className="streak-badge">
        <span>🔥</span>
        <span>{currentStreak}</span>
        <span className="text-xs opacity-80">{dayText}</span>
      </div>
      {longestStreak > currentStreak && (
        <div className="text-right">
          <p className="text-xs text-gray-500">{bestText}</p>
          <p className="font-semibold text-gray-700">{longestStreak} {daysText}</p>
        </div>
      )}
    </div>
  );
}
